export function getEntityListItemTooltip(value) {
  return value.tooltipContent
}

export function getEntityListItemTooltipPlacement(value) {
  return value.tooltipPlacement
}
